import React from "react";
import { Typography } from "@mui/material";
import { ShieldOff } from "lucide-react";
import { motion, useReducedMotion } from "motion/react";
import { Surface } from "../../Common/Surface";
import { entryVariants, resolveTransition } from "../motion";

export interface RefusalCardProps {
  /** Optional text the model emitted before refusing — usually empty;
   *  when blank we fall back to a generic message so the card still
   *  reads as a structured refusal, not as an empty bubble. */
  text?: string | null;
}

/**
 * Muted glass card rendered when the backend sends a bot_refusal frame
 * (Anthropic stop_reason="refusal"). Visually distinct from a generic
 * error: the assistant chose not to help, not that the system fell over.
 */
export function RefusalCard({ text }: RefusalCardProps) {
  const body = (text && text.trim()) || "I can't help with that.";
  const reduce = useReducedMotion() ?? false;
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={entryVariants}
      transition={resolveTransition(reduce)}
    >
      <Surface
        level="mid"
        sx={{
          my: 1,
          px: 1.5,
          py: 1,
          color: "text.secondary",
          display: "flex",
          gap: 1,
          alignItems: "flex-start",
        }}
        role="status"
        aria-label="refusal"
      >
        <ShieldOff size={16} aria-hidden style={{ marginTop: 2, flexShrink: 0 }} />
        <Typography variant="body2" component="div">
          {body}
        </Typography>
      </Surface>
    </motion.div>
  );
}
